import { Route, Routes } from "react-router";
import Home from "../../pages/home";
import MyInbox from "../../pages/publications/MyInbox";
import MyTasks from "../../pages/tasks";
import Unauthorized from "../../pages/unauthorized";
import Workflow from "../../pages/workflow";
import NotFound from "../../pages/workflow/NotFound";
import DraftForFeedback from "../../pages/workflow/Steps/DraftForFeedback";
import GeneralInformation from "../../pages/workflow/Steps/GeneralInformation";
import WaitingFeedback from "../../pages/workflow/Steps/WaitingSteps/WaitingFeedback";
import StepSelector from "../../pages/workflow/StepSelector";
import TaskView from "../../pages/tasks/task";
import Search from "../../pages/publications/Search";
import Publications from "../../pages/publications/Search/Publications";
import PublicationsInProgress from "../../pages/publications/Search/PublicationsInProgress";
import PublicationView from "../../pages/publications/View";
import Summary from "../../pages/summary";
import FinalDraft from "../../pages/workflow/Steps/FinalDraft";
import WaitingDraftApproval from "../../pages/workflow/Steps/WaitingSteps/WaitingDraftApproval";
import Admin from "../../pages/admin";
import TeamEdit from "../../pages/admin/teams/TeamEdit";
import FinalVersion from "../../pages/workflow/Steps/FinalVersion";
import WaitingFinalVersionApproval from "../../pages/workflow/Steps/WaitingSteps/WaitingFinalVersionApproval";
import Metadata from "../../pages/workflow/Steps/Metadata";
import Published from "../../pages/workflow/Steps/Published";
import WaitingPublished from "../../pages/workflow/Steps/WaitingSteps/WaitingPublished";
import GeneralInformationDelete from "../../pages/workflow/Steps/GeneralInformation/GeneralInformationDelete";
import WaitingDelete from "../../pages/workflow/Steps/WaitingSteps/WaitingDelete";
import WaitingDeleteApproval from "../../pages/workflow/Steps/WaitingSteps/WaitingDeleteApproval";
import Deleted from "../../pages/workflow/Steps/Deleted";
import Teams from "../../pages/admin/teams";
import Approvers from "../../pages/admin/approvers";
import WelcomeAdmin from "../../pages/admin/welcome";
import Republish from "../../pages/republish";
import ObservationsByPublications from "../../pages/ObservationsByPublications";

export const RouterConfig: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="new-publication" element={<Workflow />}>
        <Route index element={<GeneralInformation />} />
      </Route>
      <Route path="modify-publication" element={<Workflow />}>
        <Route index element={<GeneralInformation />} />
      </Route>
      <Route path="delete-publication" element={<Workflow />}>
        <Route index element={<GeneralInformationDelete />} />
      </Route>
      <Route path="workflow" element={<Workflow />}>
        <Route
          index
          element={
            <>
              <h1>working in progress</h1>
            </>
          }
        />
        <Route path=":ticketNumber">
          <Route path="not-found" element={<NotFound />} />
          <Route index element={<StepSelector />} />
          <Route path="general-information" element={<GeneralInformation />} />
          <Route
            path="general-information-delete"
            element={<GeneralInformationDelete />}
          />
          <Route path="draft-for-feedback" element={<DraftForFeedback />} />
          <Route path="waiting-feedback" element={<WaitingFeedback />} />
          <Route path="final-draft" element={<FinalDraft />} />
          <Route
            path="waiting-draft-approval"
            element={<WaitingDraftApproval />}
          />
          <Route
            path="waiting-delete-approval"
            element={<WaitingDeleteApproval />}
          />
          <Route path="final-version" element={<FinalVersion />} />
          <Route
            path="waiting-final-approval"
            element={<WaitingFinalVersionApproval />}
          />
          <Route path="metadata" element={<Metadata />} />
          <Route
            path="waiting-publication-tasks"
            element={<WaitingPublished />}
          />
          <Route path="waiting-delete" element={<WaitingDelete />} />
          <Route path="published" element={<Published />} />
          <Route path="deleted" element={<Deleted />} />
        </Route>
      </Route>
      <Route path="summary/:ticketNumber" element={<Summary />} />
      <Route path="myInbox" element={<MyInbox />} />
      {/* <Route path="admin" element={<Admin />} /> */}
      <Route path="admin" element={<Admin />} >
        <Route index element={<WelcomeAdmin />} />
        <Route path="teams" element={<Teams />} />
        <Route path="approvers" element={<Approvers />} />
      </Route>
      <Route path="teams/:code" element={<TeamEdit />} />
      <Route path="myTasks">
        <Route index element={<MyTasks />} />
        <Route path=":taskId" element={<TaskView />} />
      </Route>
      <Route path="search" element={<Search />} />
      <Route path="publications">
        <Route index element={<Publications />} />
        <Route path=":ticketNumber" element={<PublicationView />} />
      </Route>
      <Route
        path="publicationsInProgress"
        element={<PublicationsInProgress />}
      />
      <Route path="observationsByPublications">
        <Route
          path=":ticketNumber"
          element={<ObservationsByPublications />}>
        </Route>
      </Route>
      <Route path="unauthorized" element={<Unauthorized />} />
      <Route path="republish/:ticketNumber" element={<Republish />} />
    </Routes>
  );
};
